<template>
  <div>
    <UiModal :open="status_poppad_open" @close="status_poppad_open = false">
      

      <!-- step: pad_init -->
      <div v-if="on_step === 'pad_init'" class="px-5 pt-5 pb-4">
        <h3 class="tac mb-4">
          {{lg('',{
            en: 'Place a Bid',
            zh: '竞价',
          })}}
        </h3>

        <div>

          <div class="mb-2">
            <span>
              {{lg('',{
                en:  'Your Bid Price',
                zh:  '设置竞价价格',
              })}}:
            </span>
          </div>

          <div class="d-flex mb-3">
            <input v-model.number="num_price_bid" type="text" class="form-control">
            <select 
              class="form-control ml-3"
              style="width: 100px;"
              v-model="token_id_bid"
              >
              <option 
                v-for="(item,index) of $store.state.fecfg.cfg_token_type_bid"
                :key="index"
                :value="item.id"
                style="height: 2em;"
                >
                {{item.name}}
              </option>
            </select>
          </div>
        </div>

        <hr class="my-4">

        <div v-if="token_id_bid == 'weth'" class="d-flex align-items-center mb-2">
          <span>
            {{lg('',{
              en:'Your Wallet Balance',
              zh:'钱包余额',
            })}}
          </span>
          <div v-if="token_id_bid" class="ml-auto text-right">
            <span>
              {{ $store.state.web3.account_wallet.find(coin => coin.id == 'eth').num | tofixed3 | qfw}}
              {{lg('', $store.state.web3.account_wallet.find(coin => coin.id == 'eth').names )}}
            </span>
          </div>
        </div>

        <div class="d-flex align-items-center mb-2">
          <span>
            {{lg('',{
              en:'Your Wallet Balance',
              zh:'钱包余额',
            })}}
          </span>
          <div v-if="token_id_bid" class="ml-auto text-right">
            
            <span>
              {{balance_current_token | tofixed3 | qfw}}
              {{lg('', $store.state.web3.account_wallet.find(coin => coin.id ==token_id_bid).names )}}
            </span>
          </div>
        </div>


        <div class="mb-2">
          <span>
            {{lg('',{
              en:'Service Fee',
              zh:'服务费',
            })}}
          </span>
          <span class="float-right">2.5%</span>
        </div>
        
        <div class="mb-2">
          <span>
            {{lg('',{
              en:'Total Cost',
              zh:'总费用',
            })}}
          </span>
          <span class="float-right">
            <b class="c">
              {{ num_price_bid * 1.025 | tofixed6}}
              {{lg('', $store.state.web3.account_wallet.find(coin => coin.id == token_id_bid).names )}}
            </b>
            <span class="t-gray">
              (${{num_price_bid * 1.025 | tokenToUsd(token_id_bid)}} 
              {{lg('',{
                en: 'USD',
                zh: '美元',
              })}})
            </span>
          </span>
        </div>

        <div class="d-flex justify-content-center align-items-center" style="height:100px;">

          <span 
            v-if="status_ajaxing_exchange_weth" 
            class="ui-loading-icon"
          ></span>

          <div v-else>

            <button 
              v-if="
                token_id_bid == 'weth' &&
                (!balance_current_token || num_price_bid * 1.025 > balance_current_token)
              "
              :disabled="
                !(num_price_bid * 1.025 <= balance_current_token + $store.state.web3.account_wallet.find(coin => coin.id == 'eth').num )
                "
              :class="['btn btn-primary btn-round',{'op8': num_price_bid > balance_current_token + $store.state.web3.account_wallet.find(coin => coin.id == 'eth').num}]"
              style="min-width: 120px;" 
              @click="depositWeth()"
              >
              
              
            {{lg('',{
              en:'Convert BNB to WBNB',
              zh:'将BNB转成WBNB',
            })}}
          
            </button>

            <button 
              v-else
              :disabled="num_price_bid  > balance_current_token"
              :class="['btn btn-primary btn-round',{'op8': !num_price_bid || num_price_bid  > balance_current_token}]"
              style="min-width: 120px;" 
              @click="setStep('pad_approve')"
              >
              {{lg('next')}}
            </button>
          </div>


        </div>
      </div>

      <!-- step: pad_approve & pad_bid -->
      <div v-if="on_step === 'pad_approve' || on_step === 'pad_bid'" class="p-5">

        <!-- uni top header -->
        <div>
          <h3 class="tac mb-3">
            {{lg('',{
              en:  'Next Step',
              zh:  '下一步',
            })}}
          </h3>
          <div class="mb-3 tac">
            <span :class="['mx-3 b',{'c': on_step === 'pad_approve' || on_step === 'pad_bid'}]">
              <span :class="['ui-step-num',{'on': on_step === 'pad_approve' || on_step === 'pad_bid'}]">
                1
              </span>
              {{lg('',{
                en:  'Confirm',
                zh:  '确认',
              })}}
            </span>
            <span :class="['mx-3 b',{'c': on_step === 'pad_bid'}]">
              <span :class="['ui-step-num',{'on': on_step === 'pad_bid'}]">
                2
              </span>
              {{lg('',{
                en:  'Sign',
                zh:  '签名',
              })}}
            </span>
          </div>
        </div>

        <!-- ui for approve -->
        <div v-if="on_step === 'pad_approve'" class="tac">
          <div 
            class="d-flex justify-content-center align-items-center"
            style="height: 100px;"
            >
            <button 
              class="btn btn-primary btn-round px-4" 
              style="height: 50px;"
              v-if="!status_ajaxing_approve"
              @click="actionApproveCurrentToken()" 
              >
              Approve
            </button>

            <span v-if="status_ajaxing_approve" class="ui-loading-icon"></span>
          </div>
          <div class="mt-4" style="line-height: 1.5em;">
            Confirm transaction with your wallet. Please follow wallet instructions.
          </div>
        </div>

        <!-- ui for bid -->
        <div v-if="on_step === 'pad_bid'" class="tac">
          <div 
            class="d-flex justify-content-center align-items-center"
            style="height: 100px;"
            >
            <button 
              class="btn btn-primary btn-round px-4" 
              style="height: 50px;"
              v-if="!status_bided && !status_ajaxing_bid"
              @click="actionBid()" 
              >
              {{lg('',{
                en: 'Sign Bid',
                zh: '对竞价进行签名',
              })}}
            </button>

            <span v-if="status_ajaxing_bid" class="ui-loading-icon"></span>
            <span v-if="status_bided" class="ui-loading-icon-done"></span>
          </div>
          <div class="mt-4" style="line-height: 1.5em;">
            
            {{lg('',{
                en: 'Sign Bid using your wallet.',
                zh: '用钱包对竞价进行签名',
              })}}
          </div>
        </div>
      </div>

      <!-- step: done -->
      <div v-if="on_step === 'pad_done'" class="px-5 pt-5">
        <h3 class="tac mb-2">
          {{lg('',{
            en:  'Placed a bid',
            zh:  '已竞价',
          })}}
        </h3>
        <div class="mb-4 tac">
          <b>
            {{item.name}}
          </b>
        </div>

        <div class="pic-holder mb-4">
          <!-- <img :src="item.image" style="height: 200px;"> -->
          <CpNftCoverImg
            style="height: 200px;"
            :src="item.image"
          />
        </div>

        <div class="mb-3">
          <div>
            <span>
              {{lg('',{
                en: 'Status',
                zh: '交易阶段',
              })}}
            </span>
            <span class="float-right">
              {{lg('',{
                en: 'On Bid',
                zh: '正在竞价',
              })}}
            </span>
          </div>
        </div>

        <div v-if="status_poppad_open">
          <BlockShareLinks :share_title="text_share_title"/>
        </div>
      </div>

    </UiModal>
  </div>
</template>

<script>

import bus from '@/bus.js'
import {mapActions} from 'vuex'
import BlockShareLinks from './block_share_links.vue'

export default {
  name: 'popBid',
  components: {
    BlockShareLinks,
  },
  props: [
    'item',
    'meta_item',
    'cfg_status_poppad',
  ],
  data() {
    return {
      on_step: 'pad_init',

      status_poppad_open: false,

      status_approved_current_token: false,
      status_ajaxing_approve: false,
      status_ajaxing_check_approve: false,

      // 
      num_price_bid: '',
      token_id_bid: 'weth',

      // 
      status_ajaxing_bid: false,
      status_bided: false,
      status_ajaxing_exchange_weth: false,
    }
  },
  computed: {
    text_share_title(){
      let v = this
      let mark = `Hey everyone, check this out. ${v.item.name} . #JGNdefi #BSC #Collectible #NFT`
      // 暂无中文翻译
      // if(v.$store.state.app.lang == 'zh'){
      //   mark = `Hey everyone, check this out. ${v.item.name}. #JGNdefi #BSC #Collectible #NFT`
      // }
      return mark
    },
    balance_current_token(){
      let item = this.$store.state.web3.account_wallet.find(item => item.id === this.token_id_bid)
      return !item ? '-' :item.num
    },
  },
  watch: {
    'cfg_status_poppad': {
      immediate: true,
      handler(val){
        if(val){
          this.runPop()
        }
      }
    },
    'status_poppad_open'(val){
      if(!val){
        this.$parent.btnToggleBid(false)
      }
    },
    token_id_bid(){
      this.checkApprove()
    },
  },
  methods: {
    ...mapActions([
      'buyNFT',
      'hasApproveUSDT',
      'approveUSDT',
      'hasApproveAXIS',
      'approveAXIS',
      'hasApproveCake',
      'approveCake',
      'hasApproveWBNB',
      'approveWBNB',
      'bidSignMessage',
      'fromBNBToWBNB',
    ]),

    async getOrders(){
      let v = this

      v.order = v.meta_item.bid_info
    },

    async depositWeth(){
      let v = this

      let num = v.num_price_bid * 1.05 - v.balance_current_token

      v.status_ajaxing_exchange_weth = true
      await v.fromBNBToWBNB({num})
      v.status_ajaxing_exchange_weth = false
      v.uniGetWalletBalance()
    },

    setStep(str){
      let v = this

      // no price inputed
      if(str === 'pad_approve' && (!v.num_price_bid || v.num_price_bid > v.balance_current_token || !v.token_id_bid)){
        return
      }

      // approved
      if(str === 'pad_approve' && v.status_approved_current_token){
        v.on_step = 'pad_bid'
        return
      }

      v.on_step = str
    },

    getSign(){
      // return new Promise(function(resolve,rejct){
      //   let mark = ''
      //   mark = ('00000'+Math.random()*0x1000000<<0).toString(16).slice(-6) + (new Date()).valueOf()
      //   resolve(mark)
      // })  
      var t = '1234567890'
      var a = t.length
      var n = ''
      for (let index = 0; index < 64; index++) {
        var id = Math.floor(Math.random()*a);
        n += t.charAt(id)
      }
      return n
    },

    async actionBid(){
      let v = this
      let address_my = v.$store.state.web3.account

      let salt = v.getSign()

      v.status_ajaxing_bid = true
      let form = {
        address: address_my,
        bid_price: v.num_price_bid,
        bid_token_id: v.token_id_bid,
        token_address: v.meta_item.nft_address,
        token_id: v.meta_item.nft_id,
        type: v.meta_item.type,
        sign_str: salt,

        callback: function(){
          v.status_ajaxing_bid = false
        },
        callbackOnErr: function(){
          v.status_ajaxing_bid = false
        },
      }

      v.status_ajaxing_bid = true
      let sig = await v.bidSignMessage(form)

      if(!sig){
        return
      }

      v.status_ajaxing_bid = true
      v.api('bid',{
        'address': address_my,
        'nft_address': v.meta_item.nft_address,
        'nft_id': v.meta_item.nft_id,
        'owner': v.meta_item.owner || v.$route.query.owner,
        'amount': 1,
        'salt': salt,
        'signature': sig,
        'buyValue': v.num_price_bid,
        'currency': v.token_id_bid,
        'totalValue': v.$options.filters['tokenToUsd'](v.num_price_bid, v.token_id_bid),
      }).then(function(res){
        console.log('bid done:')
        console.log(res)

        // done
        // v.status_poppad_open = false
        v.on_step = 'pad_done'
        v.status_ajaxing_bid = false
        
        // refresh page
        setTimeout(function(){
          // detail page, or gallery page
          if(v.$parent.run){
            v.$parent.run()
          }
        },2000)
      })
    },


    async actionApproveCurrentToken(){
      let v = this
      let token_type = v.token_id_bid
      // let address_my = v.$store.state.web3.account
      

      //
      if(token_type === 'eth' || token_type === 'weth'){
        v.status_ajaxing_approve = true
        await v.approveWBNB({
          callback: function(){
            v.status_approved_current_token = true
            v.status_ajaxing_approve = false
            v.on_step = 'pad_bid'
          },
          callbackOnErr: function(){
            v.status_ajaxing_approve = false
          },
        })
      }

      if(token_type === 'axis'){
        v.status_ajaxing_approve = true
        await v.approveAXIS({
          callback: function(){
            v.status_approved_current_token = true
            v.status_ajaxing_approve = false
            v.on_step = 'pad_bid'
          },
          callbackOnErr: function(){
            v.status_ajaxing_approve = false
          },
        })
      }

      if(token_type === 'cake'){
        v.status_ajaxing_approve = true
        await v.approveCake({
          callback: function(){
            v.status_approved_current_token = true
            v.status_ajaxing_approve = false
            v.on_step = 'pad_bid'
          },
          callbackOnErr: function(){
            v.status_ajaxing_approve = false
          },
        })
      }
    },

    async checkApprove(){
      let v = this
      let token_type = v.token_id_bid
      let address_my = v.$store.state.web3.account

      if(!token_type || !address_my){
        return
      }

      v.status_ajaxing_check_approve = true
      v.status_approved_current_token = false

      // check bnb/eth
      if(token_type === 'eth' || token_type === 'weth'){
        let mark = await v.hasApproveWBNB(address_my)
        v.status_approved_current_token = mark
        console.log('BNB check approve res:', mark)
      }

      // check jgn/axis
      if(token_type === 'axis'){
        let mark = await v.hasApproveAXIS(address_my)
        v.status_approved_current_token = mark
        console.log('JGN check approve res:', mark)
      }

      // check cake
      if(token_type === 'axis'){
        let mark = await v.hasApproveCake(address_my)
        v.status_approved_current_token = mark
        console.log('Cake check approve res:', mark)
      }

      v.status_ajaxing_check_approve = false
    },

    // run pop
    runPop(){
      let v = this

      v.on_step = 'pad_init'
      // v.on_step = 'pad_done'
      v.status_ajaxing_buy = false
      v.status_ajaxing_approve = false
      v.status_ajaxing_approve = false
      v.status_ajaxing_check_approve = false
      v.status_ajaxing_bid = false

      let address_my = v.$store.state.web3.account
      if(!address_my){
        // connect wallet
        bus.headervue.modalOpen = true
        this.$parent.btnToggleBuy(false)
        return
      }

      v.status_poppad_open = v.cfg_status_poppad

      //
      v.getOrders()
      
      // check approve
      v.status_ajaxing_check_approve = false
      if(!v.status_approved_current_token){
        v.checkApprove()
      }
    },
  },
  created() {
    
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  
</style>